"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Grid_1 = __importDefault(require("@material-ui/core/Grid/Grid"));
const prop_types_1 = __importDefault(require("prop-types"));
const action_icon_1 = __importDefault(require("../actionIcon/action-icon"));
const actions_dropdown_list_1 = __importDefault(require("../actions-dropdown-list/actions-dropdown-list"));
const visible_actions_1 = __importDefault(require("./visible-actions"));
require("../../styles/components/actions-select.less");
const ActionsSelect = ({ actions, visibleActions }) => (react_1.default.createElement(Grid_1.default, { container: true, direction: "row", className: "actions-select", alignItems: "center", wrap: "nowrap" },
    react_1.default.createElement(Grid_1.default, { item: true, className: "visible-actions-container" },
        react_1.default.createElement(visible_actions_1.default, { actions: visibleActions })),
    actions.length > 0 && (react_1.default.createElement(Grid_1.default, { item: true, className: "actions-dropdown-container" },
        react_1.default.createElement(actions_dropdown_list_1.default, { triggerComponent: react_1.default.createElement(action_icon_1.default, { type: "kebab" }), options: actions })))));
ActionsSelect.defaultProps = {
    actions: [],
    visibleActions: [],
};
ActionsSelect.propTypes = {
    actions: prop_types_1.default.array,
    visibleActions: prop_types_1.default.array,
};
exports.default = ActionsSelect;
//# sourceMappingURL=actions-select.js.map